import { render, staticRenderFns } from "./myselfproduct.vue?vue&type=template&id=9aae0066&scoped=true&"
import script from "./myselfproduct.vue?vue&type=script&lang=js&"
export * from "./myselfproduct.vue?vue&type=script&lang=js&"
import style0 from "./myselfproduct.vue?vue&type=style&index=0&id=9aae0066&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aae0066",
  null
  
)

export default component.exports